import { User } from "shared/types/__generated__/graphql"

/**
 * Utility function to get the initials of a user's name.
 * @param fullName - The full name of the user.
 * @returns The initials of the user's name.
 */
export function getUserInitials(
  user: Pick<User, "name" | "email"> | null | undefined,
  options?: { count?: number }
): string {
  if (!user) return ""

  const count = options?.count ?? 1

  const nameOrEmail = user.name || user.email

  const nameParts = nameOrEmail.trim().split(/\s+/)
  const initials = nameParts.map(part => part.charAt(0).toUpperCase()).join("")

  return initials.slice(0, count)
}
